/**
 * Arama sonucu gösterimi (WP 2.11, K-14): başlık + alt başlık + eşleşme nedeni. Vurgu sunucunun verdiği aralıklarla
 * düz metin parçalarından kurulur (`<mark>`); HTML ENJEKTE EDİLMEZ (`dangerouslySetInnerHTML` yok). Geçersiz/çakışan aralık
 * sessizce atlanır.
 */
import type { ReactNode } from 'react';
import type { SearchHit } from '@castinflow/shared';
import { SearchTypeBadge } from './SearchTypeBadge';

export function Highlight({
  text,
  ranges,
}: {
  text: string;
  ranges: ReadonlyArray<readonly [number, number]>;
}) {
  const out: ReactNode[] = [];
  let at = 0;
  for (const [s, e] of ranges) {
    if (s < at || e <= s || e > text.length) continue;
    if (s > at) out.push(text.slice(at, s));
    out.push(
      <mark
        key={`${String(s)}-${String(e)}`}
        className="rounded-sm bg-warning-subtle px-0.5 text-fg"
      >
        {text.slice(s, e)}
      </mark>,
    );
    at = e;
  }
  if (at < text.length) out.push(text.slice(at));
  return <>{out}</>;
}

export function SearchHitView({ hit, showType = false }: { hit: SearchHit; showType?: boolean }) {
  return (
    <span className="block min-w-0">
      <span className="flex min-w-0 items-center gap-2">
        <span className="truncate font-medium text-fg">
          <Highlight text={hit.title} ranges={hit.titleRanges} />
        </span>
        {showType ? <SearchTypeBadge type={hit.type} /> : null}
      </span>
      {hit.subtitle !== null ? (
        <span className="block truncate text-sm text-fg-muted">{hit.subtitle}</span>
      ) : null}
      {hit.match !== null ? (
        <span className="block truncate text-sm text-fg-muted" data-testid="search-hit-match">
          <span className="text-fg-subtle">{hit.match.label}: </span>
          <Highlight text={hit.match.snippet.text} ranges={hit.match.snippet.ranges} />
        </span>
      ) : null}
    </span>
  );
}
